<template>
  <div :style="{ position: 'relative' }">
    <Loading :active.sync="loading" :isFullPage="false" :zIndex="9000"></Loading>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />

    <Dialog
      :visible.sync="localShow"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      :class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="form.szadrsstamp ? 'Editar Documento de Transporte' : 'Novo Documento de Transporte'"
      @hide="close"
    >
      <form class="p-fluid p-formgrid p-grid p-pt-2" @submit.prevent="validate">

        <div class="p-field p-col-12 p-md-6">
          <label class="p-text-bold">Origem</label>
          <Dropdown
            v-model="form.origem"
            :options="origins"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione a Origem"
            @change="resetEntity"
            appendTo="body"
            :disabled="isEditMode"
          />
        </div>

        <div class="p-field p-col-12 p-md-6" v-if="form.origem === 'CL'">
          <label class="p-text-bold">Cliente</label>
          <AppAutocomplete
            fieldId="inputClientId"
            :optionLabel="getClientLabel"
            :editModel="getCurrentClient"
            :fetchFunction="fetchClients"
            optionValue="compositeKey"
            v-model="form.clientCompositeKey"
            placeholder="Pesquisar cliente..."
            @selection-change="clientChange"
            @clear-selection="resetEntity"
            appendTo="body"
            :disabled="isEditMode"
          >
            <template #option="slotProps">
              <div>
                <b>{{ slotProps.option.name }}</b><br />
                <small>NIF: {{ slotProps.option.fiscalNumber }}</small>
              </div>
            </template>
          </AppAutocomplete>
        </div>

        <div class="p-field p-col-12 p-md-6" v-else-if="form.origem === 'FL'">
          <label class="p-text-bold">Fornecedor</label>
          <AppAutocomplete
            fieldId="inputSupplierId"
            :optionLabel="getSupplierLabel"
            :editModel="getCurrentSupplier"
            :fetchFunction="fetchSuppliers"
            optionValue="supplierCompositeKey"
            v-model="form.supplierCompositeKey"
            placeholder="Pesquisar fornecedor..."
            @selection-change="supplierChange"
            @clear-selection="resetEntity"
            appendTo="body"
            :disabled="isEditMode"
          >
            <template #option="slotProps">
              <div>
                <b>{{ slotProps.option.name }}</b><br />
                <small>NIF: {{ slotProps.option.nif }}</small>
              </div>
            </template>
          </AppAutocomplete>
        </div>

        <div class="p-col-12"><hr class="p-mt-2 p-mb-2" style="border: 0; border-top: 1px solid #eee;" /></div>

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <InputText v-model="form.szadrsdesc" id="szadrsdesc" :disabled="isEditMode" />
            <label for="szadrsdesc">Descrição do Local (Ex: Armazém Central) *</label>
          </span>
        </div>

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <InputText v-model="form.nome" id="nome" />
            <label for="nome">Nome/Entidade *</label>
          </span>
        </div>

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <InputText v-model="form.morada" id="morada" />
            <label for="morada">Morada *</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.local" id="local" />
            <label for="local">Localidade *</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.codpost" id="codpost" />
            <label for="codpost">Código Postal *</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.distrito" id="distrito" />
            <label for="distrito">Distrito</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.pais" id="pais" />
            <label for="pais">País *</label>
          </span>
        </div>

        <div class="p-col-12"><label class="p-text-secondary p-text-bold">Contactos</label></div>

        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText v-model="form.email" id="email" />
            <label for="email">Email</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText v-model="form.tlmvl" id="tlmvl" />
            <label for="tlmvl">Telemóvel</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText v-model="form.telefone" id="telefone" />
            <label for="telefone">Telefone</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.latitude" id="latitude" />
            <label for="latitude">Latitude</label>
          </span>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <span class="p-float-label">
            <InputText v-model="form.longitude" id="longitude" />
            <label for="longitude">Longitude</label>
          </span>
        </div>

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <Textarea v-model="form.obs" id="obs" rows="2" />
            <label for="obs">Observações</label>
          </span>
        </div>
      </form>

      <template #footer>
        <Button label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary" @click="close" :disabled="loading" />
        <Button label="Guardar Morada" icon="pi pi-check" class="p-button-success" @click="validate" :loading="loading" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import clientService from "@/services/client.service";
import transportDocumentService from '@/services/transport-document.service';
import supplierService from '@/services/supplier.service';
import AppAutocomplete from '@/components/elements/AppAutocomplete.vue';

const getInitialForm = () => ({
  szadrsstamp: null,
  szadrsdesc: '',
  nome: '',
  morada: '',
  distrito: '',
  local: '',
  codpost: '',
  pais: 'Portugal',
  codpais: 'PT',
  email: '',
  tlmvl: '',
  telefone: '',
  obs: '',
  no: null,
  estab: 0,
  latitude: 0,
  longitude: 0,
  origem: 'CL',
  clientCompositeKey: null,
  supplierCompositeKey: null
});

export default {
  name: "DialogTransportDocumentForm",
  components: { Loading, AppAutocomplete },
  props: {
    show: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      loading: false,
      localShow: false,
      origins: [
        { label: 'Cliente', value: 'CL' },
        { label: 'Fornecedor', value: 'FL' },
        { label: 'Outro (Manual)', value: '' }
      ],
      form: getInitialForm()
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.localShow = newVal;
        if (newVal) this.onDialogOpen();
      }
    },
    localShow(newVal) {
      if (!newVal && this.show) this.$emit("close");
    }
  },
  computed: {
    isEditMode() {
      return !!this.form.szadrsstamp;
    }
  },
  methods: {
    onDialogOpen() {
      this.form = getInitialForm();
      if (this.data && Object.keys(this.data).length > 0) {

        const clonedData = JSON.parse(JSON.stringify(this.data));
        this.form = { ...this.form, ...clonedData };

        if (this.form.no) {
          const key = `${this.form.no}-${this.form.estab}`;
          if (this.form.origem === 'CL') this.form.clientCompositeKey = key;
          if (this.form.origem === 'FL') this.form.supplierCompositeKey = key;
        }
      }
    },

    resetEntity() {
      this.form.no = 0;
      this.form.estab = 0;
      this.form.clientCompositeKey = null;
      this.form.supplierCompositeKey = null;
    },

    close() {
      this.localShow = false;
      this.$emit('close');
    },

    async fetchClients(search = '') {
      const res = await clientService.query({ search });
      return res.map(c => ({ ...c, compositeKey: `${c.id}-${c.estab}` }));
    },
    async getCurrentClient(val) {
      const [id, estab] = val.split('-');
      const res = await clientService.query({ no: id, estab: estab || 0 });
      return res.length ? { ...res[0], compositeKey: val } : null;
    },
    getClientLabel(c) { return c ? `${c.name} | NIF: ${c.fiscalNumber}` : ''; },
    async clientChange(val) {
      if (!val) return;
      const [id, estab] = val.split('-');
      this.form.no = id;
      this.form.estab = estab || 0;
      const entity = await this.getCurrentClient(val);
      if (entity) this.fillFormWithEntity(entity);
    },

    async fetchSuppliers(search = '') {
      return await supplierService.query({ search });
    },
    async getCurrentSupplier(val) {
      const [id, estab] = val.split('-');
      const res = await supplierService.query({ no: id, estab: estab || 0 });
      return res.length ? { ...res[0], compositeKey: `${res[0].id}-${res[0].estab}` } : null;
    },
    getSupplierLabel(s) { return s ? `${s.name} | NIF: ${s.nif}` : ''; },
    async supplierChange(val) {
      if (!val) return;
      const [id, estab] = val.split('-');
      this.form.no = id;
      this.form.estab = estab || 0;
      const entity = await this.getCurrentSupplier(val);
      if (entity) this.fillFormWithEntity(entity);
    },

    fillFormWithEntity(e) {
      this.form.szadrsdesc = e.name;
      this.form.nome = e.name;
      this.form.morada = e.address || e.morada;
      this.form.local = e.city || e.local;
      this.form.codpost = e.zipCode || e.codpost;
      this.form.email = e.email || '';
      this.form.tlmvl = e.mobilPhone || '';
      this.form.telefone = e.telephone || '';
    },

    async validate() {
      if (!this.form.szadrsdesc || !this.form.morada) {
        this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Descrição e Morada são obrigatórios', life: 3000 });
        return;
      }
      await this.save();
    },

    async save() {
      try {
        this.loading = true;
        let response;

        if (this.form.szadrsstamp) {
          response = await transportDocumentService.updateTransportDocument(this.form.szadrsstamp, this.form);
        } else {
          response = await transportDocumentService.createTransportDocument(this.form);
        }

        if (!response || (response.status !== 200 && response.status !== 201)) {
            const msg = response?.data?.message || 'Erro ao guardar dados';
            this.$toast.add({ severity: 'error', summary: 'Erro', detail: msg, life: 4000 });
            return;
        }

        if (response.status === 200 || response.status === 201) {
          this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Morada guardada!', life: 3000 });
          this.$emit('saved');
          this.close();
        }
      } catch (error) {
        const msg = error.response?.data?.message || 'Erro ao guardar dados';
        this.$toast.add({ severity: 'error', summary: 'Erro', detail: msg, life: 4000 });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.p-field { margin-bottom: 1.5rem; }
.p-float-label { margin-top: 0.5rem; }
</style>
